import React from 'react';
import styled from 'styled-components';

const StyledBannerDiv = styled.div`
  margin-top: 0;
  margin-bottom: 10px;
  border-radius: 0;
  text-align: center;
  @media (max-width: 767px) {
    padding-left: 7.5px;
    padding-right: 7.5px;
  }
`;

interface ClaimLimitData {
    claimable_by_user: boolean;
    claim_limit_message: string;
}

const ClaimLimitBanner = ({ ...props }: ClaimLimitData) => {
    return (
        <StyledBannerDiv className={(props.claimable_by_user ? "alert-warning" : "alert-danger") + " alert span8"} >
            {props.claim_limit_message}
        </StyledBannerDiv >
    )
};

export default ClaimLimitBanner;
